import { render } from "./reservationadmin.vue?vue&type=template&id=1d1d4bf7"
import script from "./reservationadmin.vue?vue&type=script&lang=js"
export * from "./reservationadmin.vue?vue&type=script&lang=js"

import "./reservationadmin.vue?vue&type=style&index=0&id=1d1d4bf7&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__